import { useSessionStore } from '@/src/hooks/use_session_store'
import { registerPosthogLogin } from '@api/data/analytics'
import { dashboardRoutePaths } from '@features/dashboard/presentation/routes/dashboard_route_paths'
import { sessionRoutePaths } from '@features/session/presentation/session.routes'
import { useLocationModules } from '@hooks/location-module/location-module.hooks'
import { LocationModule } from '@hooks/location-module/location-module.types'
import { PROCUREMENT_AND_MARKETS_BASE_ROUTE } from '@utils/constants'
import { usePostHog } from 'posthog-js/react'
import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

function initUsetiful(w, d, s) {
  const a = d.getElementsByTagName('head')[0]
  const r = d.createElement('script')
  r.async = 1
  r.src = s
  r.setAttribute('id', 'usetifulScript')
  r.dataset.token = '676b0cc7f469d534f10c831660df35b4'
  a.appendChild(r)
}

export function AuthRoute({ children }: { children: JSX.Element }): JSX.Element {
  const { user, isLoggedIn } = useSessionStore()
  const posthog = usePostHog()

  useEffect(() => {
    if (user) {
      if (!window.usetifulTags) {
        window.usetifulTags = {
          userId: user.id,
        }
      }

      initUsetiful(window, document, 'https://www.usetiful.com/dist/usetiful.js')

      registerPosthogLogin(
        {
          userId: user.id,
          email: user.email,
          companyId: user.companyId,
          companyName: user.companyName,
          organizationId: user.organizationId ?? null,
        },
        posthog
      )
    }

    return () => {
      const script = document.getElementById('intercom-settings')
      if (script) {
        document.body.removeChild(script)
      }
    }
  }, [])

  if (!isLoggedIn) return <Navigate to={`/${sessionRoutePaths.login}`} />

  return children
}

export function getAuthRouteToNavigate(enabledModules: LocationModule[] | undefined): string {
  if (!enabledModules) return dashboardRoutePaths.dashboard
  if (enabledModules.includes(LocationModule.PROCUREMENT_FREEMIUM)) return PROCUREMENT_AND_MARKETS_BASE_ROUTE
  return dashboardRoutePaths.dashboard
}

export function UnauthRoute({ children }: { children: JSX.Element }): JSX.Element {
  const { data: enabledModulesData } = useLocationModules()
  const authenticatedRouteNavigate = getAuthRouteToNavigate(enabledModulesData?.enabledModules ?? [])
  const { isLoggedIn } = useSessionStore()
  if (isLoggedIn) return <Navigate to={authenticatedRouteNavigate} />

  return children
}
